// extracted by mini-css-extract-plugin
export var centerText = "_bu-8";
export var container = "_bu-0";
export var doughnutContainer = "_bu-7";
export var legend = "_bu-a";
export var legendItemColorDisplay = "_bu-b";
export var legendItemLabel = "_bu-d";
export var legendItemValue = "_bu-c";
export var lg = "_bu-5";
export var maxWidth = "_bu-9";
export var md = "_bu-4";
export var responsive = "_bu-6";
export var sm = "_bu-3";
export var xs = "_bu-2";
export var xxs = "_bu-1";